import React, { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import "react-responsive-carousel/lib/styles/carousel.min.css"; // Requires a loader
import { getSingleCategory } from "../api/getSingleCategory";
import { useAuth } from "../../../lib/auth";
import ProductCard from "../../product/components/productCard";
import { Loading } from "../../../components/elements/loading";

type Product = {
  id: number;
  name_ar: string;
  price: number;
  images: { image_path: string }[];
};

const SingleCategoryPage = () => {
  const { id } = useParams<{ id: string }>();
  const [categoryData, setCategoryData] = useState<any>(null); // Category data
  const { user } = useAuth(); // Current user info
  const [isDialogVisible, setDialogVisible] = useState(false); // Dialog visibility state
  const [loading, setLoading] = useState(true); // Loading state
  const navigate = useNavigate();
  const [message, setMessage] = useState<string | null>(null); // API response message

  const fetchSingleCategory = async () => {
    try {
      setLoading(true);
      const response = await getSingleCategory(id);

      if (response?.data) {
        setCategoryData(response.data);
        setMessage(response.message);
      }
    } catch (error) {
      console.error("Error fetching category:", error);
    } finally {
      setLoading(false);
    }
  };

  const handleQuantityChange = (productId: any, newQuantity: any) => {
    if (user) {
    } else {
      // Show the dialog if the user is not logged in
      setDialogVisible(true);
    }
  };

  const handleDialogClose = () => {
    setDialogVisible(false);
  };

  const handleGoToSignUp = () => {
    setDialogVisible(false);
    navigate("/register");
  };

  useEffect(() => {
    fetchSingleCategory();
  }, [id]);

  return loading === false ? (
    <div className="pb-10">
      {message ===
      "Category retrieved successfully with its products and their images" ? (
        <>
          {/* Category Header */}
          <div className="flex items-center justify-center my-6">
            <h1 className="text-3xl font-bold">{categoryData?.name_ar}</h1>
          </div>

          {/* Products Grid */}
          {categoryData.products.length > 0 ? (
            <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-5 gap-4 m-6">
              {categoryData.products.map((product: any) => (
                <ProductCard
                  categoryId={categoryData.id}
                  key={product.id}
                  product={product}
                  onQuantityChange={handleQuantityChange}
                />
              ))}
            </div>
          ) : (
            <p className="text-center mt-4 text-gray-500 w-full">
              لا توجد منتجات متاحة لهذه الفئة
            </p>
          )}
        </>
      ) : (
        <div className="flex flex-col items-center justify-center mt-20">
          <p className="text-2xl text-red-500 mb-6">لا توجد فئة بهذا الاسم</p>
          <button
            onClick={() => navigate("/")}
            className="bg-blue-500 hover:bg-blue-600 text-white px-6 py-2 rounded-md"
          >
            العودة إلى الصفحة الرئيسية
          </button>
        </div>
      )}

      {/* Dialog for Not Logged In */}
      {isDialogVisible && (
        <div className="fixed inset-0 flex items-center justify-center bg-gray-500 bg-opacity-50">
          <div className="bg-white p-6 rounded-lg shadow-lg w-1/3">
            <h3 className="text-xl mb-4 text-center">
              يجب عليك إنشاء حساب أولاً
            </h3>
            <div className="flex justify-center gap-4">
              <button
                onClick={handleGoToSignUp}
                className="bg-blue-500 hover:bg-blue-600 text-white px-6 py-2 rounded-md"
              >
                إنشاء حساب
              </button>
              <button
                onClick={handleDialogClose}
                className="bg-gray-500 hover:bg-gray-600 text-white px-6 py-2 rounded-md"
              >
                إغلاق
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  ) : (
    <Loading />
  );
};

export default SingleCategoryPage;
